import { render } from "./BrandsEdit.vue?vue&type=template&id=ef043a2a"
import script from "./BrandsEdit.vue?vue&type=script&lang=js"
export * from "./BrandsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__